import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Groups from "@/pages/Groups";
import Attendance from "@/pages/Attendance";
import CalendarPage from "@/pages/CalendarPage";
import Celebration from "@/pages/Celebration";
import Contacts from "@/pages/Contacts";
import Reports from "@/pages/Reports";
import Certificates from "@/pages/Certificates";
import Surveys from "@/pages/Surveys";
import SurveyForm from "@/pages/SurveyForm";
import PrayerWall from "@/pages/PrayerWall";
import Prayers from "@/pages/Prayers";
import Birthdays from "@/pages/Birthdays";
import UsersAdmin from "@/pages/UsersAdmin";
import Profile from "@/pages/Profile";
import Formacao from "@/pages/Formacao";
import Atendimento from "@/pages/Atendimento";
import Metas from "@/pages/Metas";
import Presentation from "@/pages/Presentation";
import HelpCenter from "@/pages/HelpCenter";

function firstAllowedPath(user) {
  if (user?.role === "coordenador") return "/dashboard";
  const map = {
    dashboard: "/dashboard", grupos: "/grupos", frequencia: "/frequencia",
    aniversariantes: "/aniversariantes", oracoes: "/oracoes", calendario: "/calendario",
    relatorios: "/relatorios", certificados: "/certificados", pesquisas: "/pesquisas",
    celebracao: "/celebracao", contatos: "/contatos",
  };
  const mods = user?.allowed_modules || [];
  for (const m of ["dashboard", "grupos", "frequencia", "aniversariantes", "oracoes", "calendario", "relatorios", "certificados", "pesquisas", "celebracao", "contatos"]) {
    if (mods.includes(m)) return map[m];
  }
  return "/aniversariantes";
}

function Protected({ children, module, adminOnly }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
        Carregando…
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  const isAdmin = !!user.is_admin || user.role === "coordenador";
  if (adminOnly && !isAdmin) return <Navigate to={firstAllowedPath(user)} replace />;
  if (module && !isAdmin && !(user.allowed_modules || []).includes(module)) {
    return <Navigate to={firstAllowedPath(user)} replace />;
  }
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="bottom-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/apresentacao" element={<Presentation />} />
            <Route path="/login" element={<Login />} />
            <Route path="/pesquisa" element={<SurveyForm />} />
            <Route path="/oracao" element={<PrayerWall />} />
            <Route path="/dashboard" element={<Protected module="dashboard"><Dashboard /></Protected>} />
            <Route path="/grupos" element={<Protected module="grupos"><Groups /></Protected>} />
            <Route path="/frequencia" element={<Protected module="frequencia"><Attendance /></Protected>} />
            <Route path="/calendario" element={<Protected module="calendario"><CalendarPage /></Protected>} />
            <Route path="/formacao" element={<Protected module="formacao"><Formacao /></Protected>} />
            <Route path="/atendimento" element={<Protected module="atendimento"><Atendimento /></Protected>} />
            <Route path="/metas" element={<Protected module="metas"><Metas /></Protected>} />
            <Route path="/relatorios" element={<Protected module="relatorios"><Reports /></Protected>} />
            <Route path="/certificados" element={<Protected module="certificados"><Certificates /></Protected>} />
            <Route path="/pesquisas" element={<Protected module="pesquisas"><Surveys /></Protected>} />
            <Route path="/oracoes" element={<Protected module="oracoes"><Prayers /></Protected>} />
            <Route path="/aniversariantes" element={<Protected module="aniversariantes"><Birthdays /></Protected>} />
            <Route path="/usuarios" element={<Protected adminOnly><UsersAdmin /></Protected>} />
            <Route path="/perfil" element={<Protected><Profile /></Protected>} />
            <Route path="/ajuda" element={<Protected><HelpCenter /></Protected>} />
            <Route path="/celebracao" element={<Protected module="celebracao"><Celebration /></Protected>} />
            <Route path="/contatos" element={<Protected module="contatos"><Contacts /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
